import { render, staticRenderFns } from "./Global.vue?vue&type=template&id=f66bd928&scoped=true"
import script from "./Global.vue?vue&type=script&lang=js"
export * from "./Global.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66bd928",
  null
  
)

export default component.exports